import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTwitter, 
  faFacebook, 
  faInstagram, 
  faLinkedin 
} from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/images/logo.png';
import '../styles/components/footer.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logo} alt="MANAGECLI Logo" className="footer-logo-img" />
  
          <div className="footer-tagline">
            {t('footer.tagline')}
          </div>
          <div className="social-icons">
            <a 
              href="https://twitter.com/managecli" 
              className="social-icon" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label={`${t('footer.social.follow')} Twitter`}
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a 
              href="https://facebook.com/managecli" 
              className="social-icon" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label={`${t('footer.social.follow')} Facebook`}
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a 
              href="https://instagram.com/managecli" 
              className="social-icon" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label={`${t('footer.social.follow')} Instagram`}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a 
              href="https://linkedin.com/company/managecli" 
              className="social-icon" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label={`${t('footer.social.follow')} LinkedIn`}
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>

        <div className="footer-navigation">
          <h3>{t('footer.navigation')}</h3>
          <ul>
            <li><Link to="/features">{t('navigation.features')}</Link></li>
            <li><Link to="/tutorial">{t('navigation.tutorial')}</Link></li>
            <li><Link to="/documentation">{t('navigation.documentation')}</Link></li>
            <li><Link to="/contact">{t('navigation.contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-social">
          <h3>{t('footer.social.title')}</h3>
          <div className="footer-by">
            By MERCY INNOVATION LAB
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer;